import { RG_TYPE as a } from "@project-rouge/rg-core";
import { useThree as c } from "@react-three/fiber";
import { memo as h, useMemo as n, useEffect as V } from "react";
import { MeshLambertMaterial as w } from "three";
import { getRgMesh as p } from "../../3d/rg-render-types/index3.js";
import { RgView as m, isRgView as u } from "../../3d/rg-render-types/index4.js";
import { jsxs as d, Fragment as g, jsx as f } from "react/jsx-runtime";
const M = new w({
  vertexColors: !0,
  transparent: !0
}), b = new w({
  vertexColors: !0,
  transparent: !0,
  depthWrite: !1
}), E = h(function({
  obj: s,
  visible: i = [a.Wall, a.Floor, a.Window, a.Door]
}) {
  const v = c((e) => e.invalidate), {
    opaqueView: r,
    transparentView: o
  } = n(() => ({
    opaqueView: new m(s, M),
    transparentView: new m(s, b)
  }), [s]);
  return n(() => r.setVisibility({
    visibility: i,
    visible: (e) => e.alpha === 1
  }), [r, i]), n(() => o.setVisibility({
    visibility: i,
    visible: (e) => !!e.alpha && e.alpha < 1
  }), [r, i]), r.traverse((e) => {
    if (!u(e))
      return;
    const t = e;
    t.userData.alpha === 1 || t.userData.alpha === 0 || (p(t).visible = !1);
  }), o.traverse((e) => {
    if (!u(e))
      return;
    const t = e, l = p(t);
    t.userData.alpha === 1 || t.userData.alpha === 0 ? l.visible = !1 : l.renderOrder = 0.1;
  }), V(() => {
    v();
  }), /* @__PURE__ */ d(g, {
    children: [/* @__PURE__ */ f("primitive", {
      object: r
    }), /* @__PURE__ */ f("primitive", {
      object: o
    })]
  });
});
export {
  E as RgViewFC
};
//# sourceMappingURL=index.js.map
